<template>
    <gi-form
        v-if="form"
        ref="form"
        :form="form"
        :on-submit-fn="onSubmitFn"
        :history="history"
        :hide-actions="hideActions"
        @success="onSuccess"
        @error="onError"
        @form-error="onFormError"
        @load-history="onLoadHistory"
        @start-history-autosave="startHistoryAutosave"
        @stop-history-autosave="stopHistoryAutosave"
    >
        <template v-if="!hideHeader" #header>
            <app-page-header class="mb-4" />
        </template>
        <template #fields="{ loading }">
            <field-group-organisation
                ref="organisation"
                :value="form"
                :loading="loading"
                require-company-info
                @input="setFormData"
            />

            <field-description
                ref="overview"
                v-model="form.overview"
                :disabled="loading"
                :label="$t('overview')"
                wysiwyg
            />
        </template>
        <template v-if="prependCancelButton" #prepend-actions>
            <app-button-cancel @click="onCancel" />
        </template>
    </gi-form>
</template>

<script>
import form from '@/mixins/form';
import history from '@/mixins/history';
import { FundManager } from '@/models';

export default {
    name: 'FundManager',
    components: {
        GiForm: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/forms/Form'
            ),
        FieldGroupOrganisation: () =>
            import(
                /* webpackChunkName: "data-entry" */
                '@/components/fields/groups/Organisation'
            )
    },
    mixins: [form, history],
    data: () => ({
        id: 'FundManager',
        model: FundManager
    })
};
</script>
